<div class="subscriptions-list">
  <app-subscriptions-list-item
    *ngFor="let plan of plans"
    [plan]="plan"
    [selected]="plan.plan === selectedPlan"
    (onSelect)="changePlan(plan.plan)"
  ></app-subscriptions-list-item>
</div>
